import React from 'react';
import { Link } from 'react-router-dom';
import styles from './QuickLinks.module.css';
import ContactUs from '../ContactUs/ContactUs';
import { getGoogleReviewUrl, getGymSwagUrl, getGymPhone, getGymSlackUrl } from './gymDirectory';

const REFER_A_FRIEND_URL = 'https://example.com/refer-a-friend-placeholder';

const QuickLinks = ({ scheduleUrl, accountUrl, gymName }) => {
  const gymSwagUrl = getGymSwagUrl(gymName);
  const gymPhone = getGymPhone(gymName);
  const gymSlackUrl = getGymSlackUrl(gymName);

  return (
    <div className={styles.QuickLinks}>
      <h3 className={styles.Title}>Quick Links</h3>
      <div className={styles.Grid}>
        {scheduleUrl && (
          <div className={styles.WithHelp}>
            <a
              href={scheduleUrl}
              target="_blank"
              rel="noopener noreferrer"
              className={styles.LinkButton}
            >
              Pike13 Schedule
            </a>
            <Link
              to="/help#cancel-reschedule"
              className={styles.HelpBadge}
              aria-label="How to cancel or reschedule a class"
              title="How to cancel or reschedule"
            >
              ?
            </Link>
          </div>
        )}
        {accountUrl && (
          <a
            href={accountUrl}
            target="_blank"
            rel="noopener noreferrer"
            className={styles.LinkButton}
          >
            Pike13 Account
          </a>
        )}
        <Link to="/logbook" className={styles.LinkButton}>Logbook</Link>
        <Link to="/gear" className={styles.LinkButton}>Gear</Link>
        <Link to="/help" className={styles.LinkButton}>Help</Link>
        <ContactUs phoneNumber={gymPhone} />
        <a
          href={getGoogleReviewUrl(gymName)}
          target="_blank"
          rel="noopener noreferrer"
          className={styles.LinkButton}
        >
          Leave a Google Review
        </a>
        <a
          href={REFER_A_FRIEND_URL}
          target="_blank"
          rel="noopener noreferrer"
          className={styles.LinkButton}
        >
          Refer a Friend ($100)
        </a>
        {gymSlackUrl ? (
          <a
            href={gymSlackUrl}
            target="_blank"
            rel="noopener noreferrer"
            className={styles.LinkButton}
          >
            Slack
          </a>
        ) : (
          <span className={styles.Placeholder}>Slack</span>
        )}
        <a
          href="https://startingstrength.com/get-started"
          target="_blank"
          rel="noopener noreferrer"
          className={styles.LinkButton}
        >
          Get Started
        </a>
        {gymSwagUrl ? (
          <a
            href={gymSwagUrl}
            target="_blank"
            rel="noopener noreferrer"
            className={styles.LinkButton}
          >
            Gym Swag
          </a>
        ) : (
          <span className={styles.Placeholder}>Gym Swag</span>
        )}
      </div>
    </div>
  );
};

export default QuickLinks;
